import { z } from 'zod';
// ---------------------------------------------------------------------------
// Cooking technique categories
// ---------------------------------------------------------------------------
export const TECHNIQUE_CATEGORIES = [
    'cutting',
    'cooking',
    'preparation',
    'baking',
    'preservation',
    'other',
];
export const techniqueCategorySchema = z.enum(TECHNIQUE_CATEGORIES);
export const TECHNIQUE_CATEGORY_LABELS = {
    cutting: { fr: 'Découpe', en: 'Cutting' },
    cooking: { fr: 'Cuisson', en: 'Cooking' },
    preparation: { fr: 'Préparation', en: 'Preparation' },
    baking: { fr: 'Pâtisserie', en: 'Baking' },
    preservation: { fr: 'Conservation', en: 'Preservation' },
    other: { fr: 'Autre', en: 'Other' },
};
// ---------------------------------------------------------------------------
// Difficulty levels
// ---------------------------------------------------------------------------
export const DIFFICULTIES = ['easy', 'medium', 'hard'];
export const difficultySchema = z.enum(DIFFICULTIES);
export const DIFFICULTY_LABELS = {
    easy: { fr: 'Facile', en: 'Easy' },
    medium: { fr: 'Moyen', en: 'Medium' },
    hard: { fr: 'Difficile', en: 'Hard' },
};
//# sourceMappingURL=techniques.js.map